<template>
  <v-breadcrumbs :items="items" :exact="true">
    <template slot="item" slot-scope="props">
      <router-link :to="props.item.to" :class="['tw-text-sm md:tw-text-xl', props.item.disabled ? 'disabled c-gray-text' : '']">{{ props.item.text }}</router-link>
    </template>
    <template v-slot:divider>
      <v-icon>mdi-chevron-right</v-icon>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'BreadCrumb',
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      dashboard: [
        {
          text: 'Dashboard',
          disabled: false,
          to: { name: 'Dashboard' },
        },
      ],
    };
  },
  computed: {
    items() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dashboard.concat(this.breadcrumbs);
    },
  },
};
</script>

<style>
.disabled {
  color: grey!important;
  pointer-events: none!important;
}
</style>
